import {
  INIT_URL,
  FETCH_EVENT_LOG_START,
  FETCH_EVENT_LOG_SUCCESS,
  FETCH_EVENT_LOG_ERROR,
  FETCH_EVENT_LOGS_START,
  FETCH_EVENT_LOGS_SUCCESS,
  FETCH_EVENT_LOGS_ERROR,
  CHANGE_PAGE_LIMIT,
  CHANGE_PAGE, INDEX_PAGE_SIZE_DEFAULT,
} from '../../constants/ActionTypes';

const INIT_STATE = {
  token: localStorage.getItem('token'),
  registrationToken: null,
  initURL: '',
  authUser: JSON.parse(localStorage.getItem('user')),
  event_logs: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: INDEX_PAGE_SIZE_DEFAULT,
    totalRecords: 0,
  },
  event_log: {
    data: null,
    loading: false,
    error: null,
  },
  users: {
    data: [],
    loading: false,
    error: null,
  },
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case INIT_URL: {
      return { ...state, initURL: action.payload };
    }

    case FETCH_EVENT_LOG_START: {
      return {
        ...state,
        event_log: {
          ...state.event_log,
          loading: true,
        },
      };
    }

    case FETCH_EVENT_LOG_SUCCESS: {
      return {
        ...state,
        event_log: {
          ...state.event_log,
          loading: false,
          data: action.payload,
        },
      };
    }

    case FETCH_EVENT_LOG_ERROR: {
      return {
        ...state,
        event_log: {
          ...state.event_log,
          loading: false,
          error: action.payload,
        },
      };
    }

    case FETCH_EVENT_LOGS_START: {
      return {
        ...state,
        event_logs: {
          ...state.event_logs,
          loading: true,
        },
      };
    }

    case FETCH_EVENT_LOGS_SUCCESS: {
      return {
        ...state,
        event_logs: {
          ...state.event_logs,
          loading: false,
          data: action.payload,
          currentPage: action.currentPage,
          totalRecords: action.totalRecords,
        },
      };
    }

    case FETCH_EVENT_LOGS_ERROR: {
      return {
        ...state,
        event_logs: {
          ...state.event_logs,
          loading: false,
          error: action.payload,
        },
      };
    }

    case CHANGE_PAGE_LIMIT: {
      return {
        ...state,
        [action.payload.type]: {
          ...state[action.payload.type],
          pageSize: action.payload.pageSize,
        },
      };
    }

    case CHANGE_PAGE: {
      return {
        ...state,
        [action.payload.type]: {
          ...state[action.payload.type],
          currentPage: action.payload.currentPage,
        },
      };
    }

    default:
      return state;
  }
};
